import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, isSupported as messagingIsSupported } from "firebase/messaging";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBJQUNl-ZwrrUtuckyB4HAlgPLAtMBZCtY",
  authDomain: "veloceflowclaude.firebaseapp.com",
  projectId: "veloceflowclaude",
  storageBucket: "veloceflowclaude.firebasestorage.app",
  messagingSenderId: "760854128958",
  appId: "1:760854128958:web:35b0dd3c53ba942234a46f",
  measurementId: "G-B46KW5WDZZ"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  // Mobile networks, VPNs, ad-blockers, and some Wi-Fi setups break
  // Firestore's default streaming transport (seen in the console as
  // "WebChannelConnection RPC 'Listen' stream transport errored" /
  // QUIC_PROTOCOL_ERROR). When that happens the live listeners silently
  // stop delivering updates — the guard app showed stale cached data, and
  // with no cache (private tab) just hung on "Loading…".
  //
  // Auto-detect when long-polling is needed and fall back to it. (We tried
  // forcing it on, but auto-detect is the version that demonstrably loaded
  // on-device; force is only worth revisiting if a real connection error
  // shows up — the guard listeners now surface those instead of hanging.)
  experimentalAutoDetectLongPolling: true,
});
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Firebase Cloud Messaging — gated behind isSupported() because Safari on
// older iOS, in-app browsers, and certain privacy modes don't support it.
// Callers should `await getMessagingIfSupported()` and handle null.
let _messaging = null;
let _messagingChecked = false;
export async function getMessagingIfSupported() {
  if (_messagingChecked) return _messaging;
  _messagingChecked = true;
  try {
    const supported = await messagingIsSupported();
    if (supported) _messaging = getMessaging(app);
  } catch (err) {
    console.warn("FCM not supported on this browser:", err);
  }
  return _messaging;
}

export default app;
